import { render, staticRenderFns } from "./tabbedBox.vue?vue&type=template&id=96e3a0f4&"
import script from "./tabbedBox.vue?vue&type=script&lang=js&"
export * from "./tabbedBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports